/**
 * PickTypeNameDropdownSearch
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../../../services/router/actions';

// Workspaces
import { makeSelectQueryStringValue } from '../../../../workspaces/react-router-selectors';

// Selectors
import { selectOptions } from './selectors';

interface Props {
    clearPageOnChange: boolean;
    updateQueryString: Function;
    pickTypeName?: string;
    options: {
        key: number,
        text: string,
        value: string
    }[];
    multiple?: boolean;
}

export class PickTypeNameDropdownSearch extends React.Component<Props> {
    handleChange = (
        event: SyntheticInputEvent<EventTarget>,
        data: { value: string }
    ) => {
        const { clearPageOnChange } = this.props;
        this.props.updateQueryString({
            ...(clearPageOnChange ? { page: undefined } : {}),
            pickTypeName: data.value || undefined,
            selectedEvent: undefined
        });
    };

    render() {
        const { pickTypeName, options, multiple } = this.props;
        return (
            <Dropdown
                placeholder="Pick #"
                search
                selection
                value={pickTypeName || null}
                clearable
                selectOnBlur={false}
                options={options}
                onChange={this.handleChange}
                lazyLoad
                fluid
                closeOnChange
                multiple={multiple}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    pickTypeName: makeSelectQueryStringValue('pickTypeName'),
    options: selectOptions
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(PickTypeNameDropdownSearch);
